/**
 * An invite waiting to be accepted (the page was opened at `/join/<code>`, or a link was
 * pasted): what it leads to, and Join once signed in to its server.
 */
import { Show, type JSX } from "solid-js";
import { useApp } from "../../app/context";

/** The pending invite, if there is one. */
export function Pending(): JSX.Element {
  const { accounts } = useApp();
  /** Whether this page is signed in to the invite's server. */
  const signedIn = () => {
    const invite = accounts.pending();
    return !!invite && accounts.sessions().some((s) => s.server === invite.link.server);
  };
  return (
    <Show when={accounts.pending()}>
      {(invite) => (
        <section class="grp home-pending" id="home-pending">
          <h3>Invite</h3>
          <Show when={invite().info} fallback={<p class="small muted">Looking at the invite…</p>}>
            {(info) => (
              <p>
                Join <b>{info().team}</b> as <b>{info().role}</b> on <span class="mono">{new URL(invite().link.server).host}</span>.
              </p>
            )}
          </Show>
          <Show when={signedIn()} fallback={<p class="small muted">Sign in or create an account on that server below, then join.</p>}>
            <span class="btnrow">
              <button type="button" class="btn primary" id="home-pending-accept" onClick={() => void accounts.accept()}>
                Join the team
              </button>
              <button type="button" class="btn" onClick={() => accounts.dismiss()}>
                Not now
              </button>
            </span>
          </Show>
        </section>
      )}
    </Show>
  );
}
